/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface DanceActivityItem
 */
export interface DanceActivityItem {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceActivityItem
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceActivityItem
     */
    danceId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceActivityItem
     */
    choreographerUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceActivityItem
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof DanceActivityItem
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof DanceActivityItem
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the DanceActivityItem interface.
 */
export function instanceOfDanceActivityItem(value: object): value is DanceActivityItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('danceId' in value) || value['danceId'] === undefined) return false;
    if (!('choreographerUserId' in value) || value['choreographerUserId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function DanceActivityItemFromJSON(json: any): DanceActivityItem {
    return DanceActivityItemFromJSONTyped(json, false);
}

export function DanceActivityItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DanceActivityItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'danceId': ApiUserTasksGetPageParameterFromJSON(json['danceId']),
        'choreographerUserId': ApiUserTasksGetPageParameterFromJSON(json['choreographerUserId']),
        'type': json['type'],
        'text': json['text'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function DanceActivityItemToJSON(json: any): DanceActivityItem {
    return DanceActivityItemToJSONTyped(json, false);
}

export function DanceActivityItemToJSONTyped(value?: DanceActivityItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'danceId': ApiUserTasksGetPageParameterToJSON(value['danceId']),
        'choreographerUserId': ApiUserTasksGetPageParameterToJSON(value['choreographerUserId']),
        'type': value['type'],
        'text': value['text'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

